import { useEffect } from 'react';
import { recheckSession, signInUrl, useSessionEnded } from './api.ts';

/**
 * After a 401 the page stays as it was (typed text too); this bar asks to sign in again.
 * Sign-in opens in a new tab and comes back to this same address there; back on this tab, /api/me is
 * asked again and the bar goes (recheckSession).
 */
export function SessionBar() {
  const ended = useSessionEnded();
  useEffect(() => {
    if (!ended) return;
    const back = () => {
      if (document.visibilityState === 'visible') void recheckSession();
    };
    window.addEventListener('focus', back);
    document.addEventListener('visibilitychange', back);
    return () => {
      window.removeEventListener('focus', back);
      document.removeEventListener('visibilitychange', back);
    };
  }, [ended]);
  if (!ended) return null;
  return (
    <div className="session-bar" role="alert">
      Your session ended —{' '}
      <a href={signInUrl()} target="_blank" rel="noopener">
        sign in again ↗
      </a>{' '}
      (a new tab), then come back here: what you typed is kept.
    </div>
  );
}
